import PlantDetailsConfig from './plant-management';
import ProducerDetailsConfig from './producer-management';
import HaulerDetailsConfig from './hauler-management';

export default [PlantDetailsConfig, ProducerDetailsConfig, HaulerDetailsConfig];
